module.exports = __webpack_public_path__ + "93a062bc9d5cc619ef57e8b96ef81a90.jpg";